import React, { useEffect, useRef, useState } from "react";
import "./landing.scss";
import TmexPhoto from "../assets/images/logo/landingLogo.png";
import glob from "./pic/glob.svg";
import header from "./pic/headerPic.svg";
import worldMap from "./pic/world-map.svg";
import mainPic from "./pic/main-pic.svg";
import mobile from "./pic/temxmobile.png";
import iranFlag from "./pic/iranFlag.png";
import googleFlag from "./pic/googlePlay.svg";
import appleFlag from "./pic/apple.svg";
import bazarFlag from "./pic/bazar.svg";
import qrCode from "./pic/qrcode.svg";
import happy from "./pic/happy.png";
import happy2 from "./pic/happy2.svg";
import film from "./pic/filmTester2.jpg";
import benefit from "./pic/benefit.svg";
import lock from "./pic/lock.svg";
import headphone from "./pic/headphone.svg";
import myInterface from "./pic/interface.svg";
import money from "./pic/money.svg";
import main2 from "./pic/main2.svg";
import telegram from "./pic/telegram.svg";
import menuBarLogo from "./pic/menu-bar-logo.svg";
import LivePrice from "./livePrice/livePrice";
import Feed from "./feed/feed.index";
import CurrencyComponent from "./CurrencyComponent/CurrencyComponent";
import Footer from "./Footer/Footer";
import axios from "axios";
import LivePriceSkeleton from "./livePrice/livePrice.skeleton";
import { Link } from "react-router-dom";
import { SERVER, SITEURL } from "../api";
import TempPhoto from "./pic/tempProfilePic.png";
import VirtualMoney from "./virtualMoneies/virtualMoneies";
import VirtualMoneiesSkeleton from "./virtualMoneies/virtualMoneies.skeleton";

function Landing() {
    const [menuBar, setMenuBar] = useState(false);
    const [livePrices, setLivePrices] = useState(null);
    const [virtualMoneies, setVirtualMoneies] = useState(null);
    const [whichActive, setWhichActive] = useState();
    const [news, setNews] = useState(null);

    function getPrices() {
        return new Promise(resolve => {
            axios
                .get(SERVER + "/Market/PriceInfos/5", "accept: text/plain")
                .then(res => {
                    setLivePrices(res.data.data);
                    resolve(true);
                });
        });
    }

    function getVirtualMoneies() {
        return new Promise(resolve => {
            axios
                .get(SERVER + "/Market/VirtualMoneies", "accept: text/plain")
                .then(res => {
                    setVirtualMoneies(res.data.data);
                    resolve(true);
                });
        });
    }

    function getNews() {
        return new Promise(resolve => {
            axios.get(SERVER + "/Blog/4", "accept: text/plain").then(res => {
                setNews(res.data.data);
                resolve(true);
            });
        });
    }

    async function getDetails() {
        const prices = await getPrices();
        const news = await getNews();
        const moneies = await getVirtualMoneies();
    }

    useEffect(() => {
        getDetails();
    }, []);

    return (
        <div id="main" className="tmex-landing">
            <div style={{ right: menuBar ? 0 : "-300px" }} className="menu-bar">
                <div className="menu-bar-container">
                    <div onClick={() => setMenuBar(false)} className="back-btn">
                        <i className="fas fa-chevron-right" />
                    </div>
                    <div className="logo-container">
                        <img src={menuBarLogo} alt={"Tmex"} />
                    </div>
                    <div className="items-container">
                        <Link className="active " to={"/"}>
                            <h4>صفحه اصلی</h4>
                        </Link>
                        <Link to={"/page/allprice"}>
                            <h4>قیمت ارزها</h4>
                        </Link>
                        <Link to={"https://blog.temx.org/"} target="_blank">
                            <h4>وبلاگ</h4>
                        </Link>
                        <Link
                            className={`${
                                whichActive === "laws" ? "active" : ""
                            } `}
                            to={"/page/laws/"}
                        >
                            <h4>قوانین و مقررات</h4>
                        </Link>
                        <Link
                            className={`${
                                whichActive === "FAQ" ? "active" : ""
                            } `}
                            to={"/page/FAQ"}
                        >
                            <h4>سوالات متداول</h4>
                        </Link>
                        <Link
                            className={`${
                                whichActive === "paytime" ? "active" : ""
                            } `}
                            to={"/page/paytime/"}
                        >
                            <h4>زمان تسویه حساب</h4>
                        </Link>
                        <Link
                            className={`${
                                whichActive === "permission" ? "active" : ""
                            } `}
                            to={"/page/permission/"}
                        >
                            <h4>سطوح کاربری</h4>
                        </Link>
                        <Link
                            className={`${
                                whichActive === "affiliate" ? "active" : ""
                            } `}
                            to={"/page/affiliate/"}
                        >
                            <h4>کسب درآمد</h4>
                        </Link>
                        <Link
                            className={`${
                                whichActive === "contact" ? "active" : ""
                            } `}
                            to={"/page/contact/"}
                        >
                            <h4>ارتباط با ما</h4>
                        </Link>
                        <Link
                            className={`${
                                whichActive === "about" ? "active" : ""
                            } `}
                            to={"/page/about/"}
                        >
                            <h4>درباره ما</h4>
                        </Link>
                    </div>

                    <div className="bottom">
                        <div className="social-media">
                            <i className="fab fa-instagram" />
                            <i className="fab fa-linkedin-in" />
                            <i className="fab fa-twitter" />
                            <i className="fab fa-facebook-f" />
                        </div>
                        <p>
                            {" "}
                            تمام حقوق مادی و معنوی این وبسایت© متعلق به تم ایکس
                            بوده و هرگونه کپی برداری از آن پیگرد قانونی دارد
                        </p>
                    </div>
                </div>
            </div>
            {menuBar && (
                <div
                    onClick={() => setMenuBar(false)}
                    className="black-background"
                />
            )}
            <div className="header-background">
                <img className="header-pic" src={header} alt={"header"} />
                <div className="header">
                    <img className="glob-picture" src={glob} alt={"glob"} />

                    <div className="change-currency">
                        <CurrencyComponent />
                    </div>
                    <div className="header-text">
                        <h2>انتقال سریع و بدون محدودیت ارز</h2>
                        <h4>
                            ما در کمتر از ۱ دقیقه ارز شما را به هر جای دنیا
                            انتقال می دهیم
                        </h4>
                    </div>
                    <div
                        onClick={() => setMenuBar(true)}
                        className="d-flex d-lg-none login"
                    >
                        <i className="fas fa-bars" />
                    </div>
                    <img id="title" src={TmexPhoto} alt="logo" />
                    <div className="d-none d-lg-flex items">
                        <div className="items-container">
                            <h4 className="active">صفحه اصلی</h4>
                            <Link to={"/page/allprice"}>
                                <h4>قیمت ارزها</h4>
                            </Link>

                            <h4
                                onClick={e => {
                                    window.open(
                                        "https://blog.temx.org/",
                                        "_blank"
                                    );
                                }}
                            >
                                وبلاگ
                            </h4>

                            <Link to={"/page/laws"}>
                                <h4>قوانین و مقررات</h4>
                            </Link>
                            <Link to={"/page/FAQ"}>
                                <h4>سوالات متداول</h4>
                            </Link>
                        </div>
                    </div>
                    <Link
                        to={
                            localStorage.getItem("phone")
                                ? "/userpanel/order"
                                : "/authorization/"
                        }
                        className="login"
                    >
                        <p className="d-none d-lg-block">
                            {localStorage.getItem("phone")
                                ? "پنل کاربری"
                                : "ورود"}
                        </p>
                        <i className="fas fa-user" />
                    </Link>
                </div>
            </div>
            <div className="virtual-money">
                <h2>قیمت ارزهای دیجیتال و تتر</h2>
                <p style={{ marginBottom: "0" }}>
                    با تم ایکس در 3 مرحله خرید و فروش کنید
                </p>
                <p>انتخاب پرداخت دریافت</p>
                <img className="world-map-pic" src={worldMap} alt="worldMap" />
                {virtualMoneies ? (
                    virtualMoneies
                        .filter(
                            i =>
                                i.symbol.toLowerCase() === "pm" ||
                                i.symbol.toLowerCase() === "usdt"
                        )
                        .map((item, index) => (
                            <VirtualMoney
                                id={item.symbol}
                                name={item.name}
                                price={item.price}
                                image={SITEURL + `${item.icon}`}
                            />
                        ))
                ) : (
                    <React.Fragment>
                        <VirtualMoneiesSkeleton />
                        <VirtualMoneiesSkeleton />
                    </React.Fragment>
                )}
            </div>
            <div className="live-price">
                <h2>قیمت لحظه‌ای ارزها</h2>

                <img className="world-map-pic" src={worldMap} alt="worldMap" />
                {livePrices ? (
                    livePrices.map((item, index) => (
                        <LivePrice
                            id={item.symbol}
                            name={item.name}
                            price={
                                item.weeklyPriceLog[
                                    item.weeklyPriceLog.length - 1
                                ]
                            }
                            image={SITEURL + `${item.icon}`}
                            changeAmout={item.changeOf24HourAmount}
                            changePercent={item.changeOf24HourPercent}
                            data={item.weeklyPriceLog}
                        />
                    ))
                ) : (
                    <React.Fragment>
                        <LivePriceSkeleton />
                        <LivePriceSkeleton />
                        <LivePriceSkeleton />
                        <LivePriceSkeleton />
                        <LivePriceSkeleton />
                    </React.Fragment>
                )}
            </div>

            <div className="mobile ">
                <img className="main-pic" src={mainPic} alt="main" />
                <h2 className="d-block d-lg-none">اپلیکیشن موبایل تم ایکس</h2>
                <h3 className="d-block d-lg-none">
                    خرید و فروش ارز دیجیتال بدون واسطه!
                </h3>

                <img className="mobile-pic" src={mobile} alt="main" />
                <div className="mobile-info">
                    <h2 className="d-none d-lg-block">
                        اپلیکیشن موبایل تم ایکس
                    </h2>
                    <h3 className="d-none d-lg-block">
                        خرید و فروش ارز دیجیتال بدون واسطه!
                    </h3>
                    <p id="text">
                        خرید و فروش ارز دیجیتال در کمتر از 1 دقیقه با اپلیکیشن
                        موبایل به آسانی و در هر لحظه به خرید، فروش و تبدیل
                        ارزهای دیجیتال بپردازید و از آخرین اخبار ارزهای دیجیتال
                        مطلع شوید.
                    </p>
                    <div className="my-container">
                        <div className="flags">
                            <img
                                className="flag"
                                src={googleFlag}
                                alt="google"
                            />
                            <img
                                onClick={() =>
                                    window.open(
                                        "https://pwa.temx.org",
                                        "_blank"
                                    )
                                }
                                className="flag"
                                src={appleFlag}
                                alt="apple"
                            />
                            <img
                                onClick={() =>
                                    window.open(
                                        "https://cafebazaar.ir/app/ir.temx.app",
                                        "_blank"
                                    )
                                }
                                className="flag"
                                src={bazarFlag}
                                alt="bazar"
                            />
                        </div>
                        <div className="link">
                            <div className="social">
                                <i className="fab fa-instagram" />
                                <i className="fab fa-linkedin-in" />
                                <i className="fab fa-twitter" />
                                <i className="fab fa-facebook-f" />
                            </div>
                            <span />
                            <div className="qr">
                                <i className="fas fa-qrcode" />
                                <div className="text">
                                    <h4>دانلود اپلیکیشن</h4>
                                    <p>با گوشی اسکن کنید</p>
                                </div>

                                <img
                                    className="flag"
                                    src={qrCode}
                                    alt="qrcode"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="why">
                <div className="text">
                    <div className="text-container">
                        <h2>چرا تم ایکس؟</h2>

                        <div className="more-info">
                            <div
                                onClick={() =>
                                    window.open("/page/about/", "_blank")
                                }
                                className="btn"
                            >
                                <p>اطلاعات بیشتر</p>
                                <div className="icon">
                                    <i className="fas fa-chevron-left" />
                                </div>
                            </div>
                            <span />
                            <div className="call">
                                <div className="d-none d-lg-flex icon">
                                    <i className=" fas fa-phone-alt" />
                                </div>
                                <div className="call-info">
                                    <p id="text">با ما تماس بگیرید</p>
                                    <p id="number">021-91016626</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="image">
                    <div className="container">
                        <img id="img1" src={happy} alt="tmex" />
                        <img id="img2" src={happy2} alt="tmex" />
                    </div>
                </div>
            </div>
            <div className="video-instruction">
                <h2>ویدیو معرفی تم ایکس</h2>
                <div className="container">
                    <video
                        controls
                        poster={film}
                        title="ویدیو معرفی تم ایکس"
                        src="https://api.temx.org/media/video/tiser.mp4"
                    />
                </div>
            </div>
            <div className="benefit">
                <div className="benefit-container">
                    <img src={benefit} alt="benefit" />
                    <div className="text">
                        <h2>مزایای خرید و فروش در تم ایکس</h2>
                        <p>با تم ایکس خرید و فروش متفاوت را تجربه کنید</p>
                    </div>
                </div>
                <div className="items-container">
                    <div className="items">
                        <img src={lock} alt="lock" />
                        <h3>امنیت در معاملات آنلاین</h3>
                        <p>
                            استفاده از آخرین استانداردهای امنیتی وب با انجام
                            آزمون‌های دوره‌ای نفوذ توسط کارشناسان معتبر هک و
                            امنیت
                        </p>
                    </div>
                    <div className="items">
                        <img src={money} alt="money" />
                        <h3>قیمت منصفانه</h3>
                        <p>
                            ارائه قیمت های مناسب با ایجاد فضایی رقابتی در خرید و
                            فروش جهت رضایتمندی حداکثری کاربران
                        </p>
                    </div>
                    <div className="items">
                        <img src={myInterface} alt="interface" />
                        <h3>رابط کاربری آسان</h3>
                        <p>
                            قابلیت خرید و فروش در وب سایت، نرم افزار موبایل و
                            ربات تلگرامی با محیطی ساده، روان و کاربرپسند
                        </p>
                    </div>
                    <div className="items">
                        <img src={headphone} alt="headphone" />
                        <h3>پشتیبانی آنلاین</h3>
                        <p>
                            پاسخگویی و راهنمایی کاربران توسط کارشناسان تم ایکس
                            در محیط وب سایت و اپلیکیشن موبایل
                        </p>
                    </div>
                </div>
            </div>
            <div className="telegram">
                <h2 id="top" className="d-block d-lg-none">
                    مزایای استفاده از ربات تلگرامی تم ایکس
                </h2>
                <h3 id="top" className="d-block d-lg-none"></h3>

                <img id="main2" src={main2} alt="main2" />
                <img id="telegram" src={telegram} alt="telegram" />
                <div className="benefit-text">
                    <h2 className="d-none d-lg-block">
                        مزایای استفاده از ربات تلگرامی تم ایکس
                    </h2>
                    <h3 className="d-none d-lg-block"></h3>
                    <div className="items">
                        <i className="fas fa-circle" />
                        <p>درگاه بانکی ایمن</p>
                    </div>
                    <div className="items">
                        <i className="fas fa-circle" />
                        <p>ارائه ۲۴ ساعته خدمات</p>
                    </div>
                    <div className="items">
                        <i className="fas fa-circle" />
                        <p>خرید و فروش اتوماتیک ارزهای دیجیتال</p>
                    </div>
                    <div className="items">
                        <i className="fas fa-circle" />
                        <p>سریعترین سرعت تبدیل، کاملا اتوماتیک</p>
                    </div>
                    <div className="items">
                        <i className="fas fa-circle" />
                        <p>تبدیل تتر  به ارزهای دیجیتال و بالعکس</p>
                    </div>
                    <div className="items">
                        <i className="fas fa-circle" />
                        <p>اتصال مستقیم به حساب کاربری شما در تم ایکس</p>
                    </div>
                    <a
                        href="https://t.me/Temx_bot"
                        target="_blank"
                        className="telegram-btn"
                    >
                        <i className="fab fa-telegram-plane" />
                        <div className="info">
                            <h4>لینک عضویت ربات</h4>
                            <p>Temx_bot@</p>
                        </div>
                    </a>
                </div>
            </div>
            {news && (
                <div className="feed">
                    <h2 className="feed-title">
                        مقالات و آخرین اخبار ارز های دیجیتال و بازارهای مالی
                    </h2>
                    <p className="feed-detail">
                        با تم ایکس از جدید ترین اخبار ارز های دیجیتال و آخرین
                        تحولات بازار مطلع شوید.
                    </p>
                    <div className="feed-container">
                        {news.map((item, index) => (
                            <Feed
                                image={item.urlImage}
                                topic={item.category}
                                like={item.url}
                                profilePic={TempPhoto}
                                time={new Date(
                                    item.publishDate
                                ).toLocaleDateString("fa")}
                                author={item.author}
                                text={item.description}
                                title={item.title}
                                key={index}
                            />
                        ))}
                    </div>
                </div>
            )}
            <p className="copy-right">تمامی حقوق برای تم ایکس محفوظ است</p>
            <div>
                <Footer />
            </div>
            <a href="#main" className="scroll-up">
                <i className="fas fa-arrow-up" />
            </a>
        </div>
    );
}

export default Landing;
